import { NavLink } from "react-router-dom";
import { Pin, PinOff, Star } from "lucide-react";
import { labelSlug } from "./utils";

/**
 * A top-level `type:"link"` nav item (not nested inside any group).
 * Renders slightly larger than a leaf (SidebarItemRow) — icon left, label
 * flush-left, pin icon on hover, ⭐ badge if pinned.
 */
export default function SidebarLink({ item, isPinned, onTogglePin, onContextMenu, collapsed, location }) {
  const Icon = item.icon;
  const testId = `sidebar-nav-${labelSlug(item.label)}`;
  const isActive = location.pathname === item.to || location.pathname.startsWith(item.to + "/");
  const pinned = isPinned(item.to);

  return (
    <NavLink
      to={item.to}
      onContextMenu={onContextMenu}
      data-testid={testId}
      className={({ isActive: navActive }) => {
        const active = navActive || isActive;
        return `group relative flex items-center ${collapsed ? "justify-center px-2" : "px-3"} py-2 rounded-md text-sm transition-colors ${
          active
            ? "bg-white/[0.08] text-white"
            : "text-slate-300 hover:bg-white/[0.04] hover:text-white"
        }`;
      }}
      title={collapsed ? item.label : undefined}
    >
      {({ isActive: navActive }) => (
        <>
          {(navActive || isActive) && (
            <span className="absolute left-0 top-1.5 bottom-1.5 w-[3px] rounded-r bg-orange-400" aria-hidden="true" />
          )}
          <Icon className={`w-4 h-4 shrink-0 ${item.color || "text-slate-300"}`} />
          {!collapsed && (
            <>
              <span className="ml-2.5 truncate">{item.label}</span>
              {pinned && <Star className="w-3 h-3 shrink-0 text-orange-400 fill-orange-400/40 ml-1.5" />}
              <button
                type="button"
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); onTogglePin(); }}
                data-testid={`${testId}-pin`}
                aria-label={pinned ? "Unpin" : "Pin to sidebar"}
                className={`ml-auto shrink-0 w-6 h-6 grid place-items-center rounded transition-opacity ${
                  pinned
                    ? "opacity-100 text-orange-400 hover:bg-white/5"
                    : "opacity-0 group-hover:opacity-100 text-slate-400 hover:text-orange-400 hover:bg-white/5"
                }`}
              >
                {pinned ? <PinOff className="w-3.5 h-3.5" /> : <Pin className="w-3.5 h-3.5" />}
              </button>
            </>
          )}
        </>
      )}
    </NavLink>
  );
}
